import _slicedToArray from "/opt/build/repo/node_modules/.pnpm/next@15.5.6_@babel+core@7.28.5_@opentelemetry+api@1.9.0_@playwright+test@1.56.1_babel-p_096ab9bbeffdff0fc88514782f3793fe/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import * as React from 'react';
import { getCookie } from 'docs/src/modules/utils/helpers';
import { CODE_STYLING } from 'docs/src/modules/constants';
import { jsx as _jsx } from "react/jsx-runtime";
var CodeStylingContext = /*#__PURE__*/React.createContext({
  codeStyling: CODE_STYLING.SYSTEM,
  setCodeStyling: function setCodeStyling() {}
});
if (false) CodeStylingContext.displayName = "CodeStylingContext";
if (false) {
  CodeStylingContext.displayName = 'CodeStyling';
}
function useFirstRender() {
  var firstRenderRef = React.useRef(true);
  React.useEffect(function () {
    firstRenderRef.current = false;
  }, []);
  return firstRenderRef.current;
}
export function CodeStylingProvider(props) {
  var children = props.children;
  var _React$useState = React.useState(CODE_STYLING.SYSTEM),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    codeStyling = _React$useState2[0],
    setCodeStyling = _React$useState2[1];
  var navigatedCodeStyling = React.useMemo(function () {
    var navigatedCodeMatch = true ? window.location.hash.match(/\.(js|tsx)$/) : null;
    if (navigatedCodeMatch === null) {
      return undefined;
    }
    if (true) {
      if (window.location.hash.includes('tailwind-')) {
        return CODE_STYLING.TAILWIND;
      }
      if (window.location.hash.includes('css-')) {
        return CODE_STYLING.CSS;
      }
      if (window.location.hash.includes('system-')) {
        return CODE_STYLING.SYSTEM;
      }
    }
    return undefined;
  }, []);
  var persistedCodeStyling = React.useMemo(function () {
    if (false) {
      return undefined;
    }
    return getCookie('codeStyling');
  }, []);
  var isFirstRender = useFirstRender();

  // We initialize from navigation or cookies. on subsequent renders the store is the truth
  var noSsrCodeStyling = isFirstRender === true ? navigatedCodeStyling || persistedCodeStyling || codeStyling : codeStyling;
  React.useEffect(function () {
    if (codeStyling !== noSsrCodeStyling) {
      setCodeStyling(noSsrCodeStyling);
    }
  }, [codeStyling, noSsrCodeStyling]);
  React.useEffect(function () {
    document.cookie = "codeStyling=".concat(codeStyling, ";path=/;max-age=31536000");
  }, [codeStyling]);
  var contextValue = React.useMemo(function () {
    return {
      codeStyling: codeStyling,
      noSsrCodeStyling: noSsrCodeStyling,
      setCodeStyling: setCodeStyling
    };
  }, [codeStyling, noSsrCodeStyling]);
  return /*#__PURE__*/_jsx(CodeStylingContext.Provider, {
    value: contextValue,
    children: children
  });
}
false ? void 0 : void 0;
export function useCodeStyling() {
  return React.useContext(CodeStylingContext).codeStyling;
}
export function useNoSsrCodeStyling() {
  return React.useContext(CodeStylingContext).noSsrCodeStyling;
}
export function useSetCodeStyling() {
  return React.useContext(CodeStylingContext).setCodeStyling;
}